import { Injectable, EventEmitter } from "@angular/core";

import { HttpCemex } from "@cemex-core/angular-services-v8";

import { EndpointsConstants } from "./../../../cemexcomponents/constants/v2/";
import { countryList, countryParameter, paymentMethod } from "./../../interfaces/configurationParameters";

@Injectable()
export class CountryConfigurationService {
  private apiCountryParameters: string;
  private apiCountryList: string;
  private apiPaymentMethods: string;
  params$: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpCemex, private endpoint: EndpointsConstants) {
    this.apiCountryParameters = "countryparameters";
    this.apiCountryList = "countrieslist";
    this.apiPaymentMethods = "paymentmethods";
  }

  private getUrl(api: string): string {
    return this.endpoint.getBasePath() + this.endpoint.V2 + this.endpoint.rcCapability + api;
  }

  getCountryList(): Promise<Array<countryList>> {
    return this.http
      .get(this.getUrl(this.apiCountryList))
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  getCountryParameter(countryCode?: string): Promise<Array<any>> {
    return this.http
      .get(this.getUrl(this.apiCountryParameters) + "?countryCode=" + countryCode)
      .toPromise()
      .then((response: any) => {
        this.params$.emit(response);
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  getPaymentMethods(): Promise<Array<paymentMethod>> {
    return this.http
      .get(this.getUrl(this.apiPaymentMethods))
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  saveConfigurationCountry(countryParameters: any) {
    return this.http
      .post(this.getUrl(this.apiCountryParameters), countryParameters)
      .toPromise()
      .then((response) => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  editConfigurationCountry(countryParameters: any) {
    return this.http
      .put(this.getUrl(this.apiCountryParameters), countryParameters)
      .toPromise()
      .then((response) => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  deleteConfigurationCountry(params: any) {
    return this.http
      .put(this.getUrl(this.apiCountryParameters), params)
      .toPromise()
      .then((response) => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
